/**
 * Analytics — GA4 com Consent Mode v2
 *
 * - Antes do consentimento: gtag carregado com analytics_storage=denied
 * - Após aceitar: atualiza consent e envia pageviews
 * - Após recusar: permanece denied, nenhum dado enviado
 */

const GA_ID = process.env.REACT_APP_GA_ID;

export const CONSENT_KEY = 'libben_cookie_consent';

// Inicializa gtag com consent denied (antes de qualquer interação)
export function initAnalytics() {
  if (!GA_ID || typeof window === 'undefined') return;
  if (window.__gaInitialized) return;
  window.__gaInitialized = true;

  // Injeta script do GA4
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());

  // Consent Mode v2 — denied por padrão
  window.gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    wait_for_update: 500,
  });

  window.gtag('config', GA_ID, { send_page_view: false });

  // Se já tinha consentimento salvo, aplica imediatamente
  const saved = localStorage.getItem(CONSENT_KEY);
  if (saved === 'accepted') grantConsent();
}

export function grantConsent() {
  if (!window.gtag) return;
  window.gtag('consent', 'update', {
    analytics_storage: 'granted',
  });
  window.gtag('event', 'page_view', {
    page_location: window.location.href,
    page_title: document.title,
  });
  localStorage.setItem(CONSENT_KEY, 'accepted');
}

export function denyConsent() {
  if (!window.gtag) return;
  window.gtag('consent', 'update', {
    analytics_storage: 'denied',
  });
  localStorage.setItem(CONSENT_KEY, 'denied');
}

export function trackPageView(path) {
  if (!window.gtag || localStorage.getItem(CONSENT_KEY) !== 'accepted') return;
  window.gtag('event', 'page_view', {
    page_location: window.location.origin + path,
    page_title: document.title,
  });
}

export function trackEvent(eventName, params = {}) {
  if (!window.gtag || localStorage.getItem(CONSENT_KEY) !== 'accepted') return;
  window.gtag('event', eventName, params);
}
